<ng-container *ngIf="jobOrders.length">
  <div class="job-orders">
    <table
      matSort
      mat-table
      [dataSource]="jobOrders"
      (matSortChange)="sortData($event)"
    >
      <ng-container matColumnDef="jobName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head"> Job name </span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <input type="text" class="item" value="{{ job.code }}" disabled />
        </td>
      </ng-container>
      <ng-container matColumnDef="finalCustomer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head"> Final customer </span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <input
            type="text"
            class="item"
            value="{{ job.finalCustomer }}"
            disabled
          />
        </td>
      </ng-container>
      <ng-container matColumnDef="deliveryDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head"> Delivery date </span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <input
            type="text"
            class="item"
            size="20"
            value="{{ job.deliveryDate | date: 'short' }}"
            disabled
          />
        </td>
      </ng-container>
      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head"> Start date </span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <input
            type="text"
            class="item"
            size="20"
            value="{{ job.startDate | date: 'short' }}"
            disabled
          />
        </td>
      </ng-container>
      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head"> End date </span>
        </th>
        <td mat-cell (click)="onDetailClick(job.id)" *matCellDef="let job">
          <input
            type="text"
            class="item"
            size="20"
            value="{{ job.endDate | date: 'short' }}"
            disabled
          />
        </td>
      </ng-container>
      <ng-container matColumnDef="ops">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="item-head"> Actions </span>
        </th>
        <td mat-cell *matCellDef="let job">
          <button (click)="onUpdateClick(job.id)" mat-icon-button>
            <mat-icon aria-label="Update">create</mat-icon>
          </button>
          <button (click)="onDeleteClick(job.id)" mat-icon-button>
            <mat-icon aria-label="Delete">delete</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
    </table>
  </div>
</ng-container>
